function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(3.789 5.159)"
}, React.createElement("rect", {
  width: 32.704,
  height: 31.536,
  rx: 4,
  transform: "translate(-3.789 -5.159)",
  fill: "#00ffba"
}), React.createElement("g", {
  transform: "translate(2 0.962)"
}, React.createElement("path", {
  d: "M19.7,13.93V9.5a7.534,7.534,0,0,0-5.446-7.216v-.2a2.125,2.125,0,0,0-1.77-2.11,2.06,2.06,0,0,0-2.314,2.042v.272A7.534,7.534,0,0,0,4.723,9.5V13.93a2.7,2.7,0,0,1-2.178,2.655A.735.735,0,0,0,2,17.3H2a.7.7,0,0,0,.715.715H21.707a.7.7,0,0,0,.715-.715h0a.735.735,0,0,0-.545-.715A2.7,2.7,0,0,1,19.7,13.93Z",
  transform: "translate(-2 0.038)",
  fill: "#fff"
})), React.createElement("g", {
  transform: "translate(9.828 19.375)"
}, React.createElement("path", {
  d: "M29.22,57H25a2.383,2.383,0,0,0,4.765,0Z",
  transform: "translate(-25 -57)",
  fill: "#fff"
})));

var SvgNotificationSolid = function SvgNotificationSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32.704,
    height: 31.536,
    viewBox: "0 0 32.704 31.536",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotificationSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification-solid.63b45358.svg";
export { ForwardRef as ReactComponent };